import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig'; 
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";

const Daily_deposit = () => {
  const [data, setData] = useState([]); 
  const [totalAmount, setTotalAmount] = useState(0); 
  const [totalBonus, setTotalBonus] = useState(0); 
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [statusFilter, setStatusFilter] = useState("paid");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [userId, setUserId] = useState(null);

  const currentPage = useRef(1);

  // Extract user_id from URL hash
  useEffect(() => {
    const hash = window.location.hash; // e.g., "#/daily-deposit?user_id=123"
    const queryString = hash.split("?")[1];
    if (queryString) {
      const params = new URLSearchParams(queryString);
      const id = params.get("user_id");
      if (id) setUserId(id);
    }
  }, []);

  // Fetch deposits whenever filters, pagination, or userId changes
  useEffect(() => {
    if (userId) getPaginatedUsers();
  }, [limit, startDate, endDate, statusFilter, userId]);

  const getPaginatedUsers = async () => {
    try {
      const formattedStartDate = startDate ? startDate.toISOString() : "";
      const formattedEndDate = endDate ? endDate.toISOString() : "";

      const response = await axios.get(`${apiConfig.baseURL}/api/agent/daily_deposit`, {
        params: {
          page: currentPage.current,
          limit,
          status: statusFilter === 'all' ? undefined : statusFilter,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          user_id: userId
        }
      });

      if (response.status === 200) {
        const respData = response.data;
        setPageCount(respData.pageCount || 1);
        setTotalAmount(respData.totalAmount || 0);
        setTotalBonus(respData.totalBonus || 0);
        const sortedData = (respData.result || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setData(sortedData);
      }
    } catch (error) {
      console.error('Error fetching paginated users:', error);
      alert('Error fetching paginated users: ' + error.message);
    }
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  const handleApprovePayment = async (depositId, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_transfer_update`, { depositId });
      getPaginatedUsers();
      alert(response.data.message);
    } catch (error) {
      console.error('Error approving payment:', error);
      alert('Error approving payment: ' + error.message);
    }
  };

  const handleRejectPayment = async (depositId, event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiConfig.baseURL}/api/agent/user_transfer_reject`, { depositId });
      getPaginatedUsers();
      alert(response.data.message);
    } catch (error) {
      console.error('Error rejecting payment:', error);
      alert('Error rejecting payment: ' + error.message);
    }
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { hour: 'numeric', minute: 'numeric', hour12: true };
    const timeString = date.toLocaleString('en-US', options);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${timeString.toLowerCase()} ${day}/${month}/${year}`;
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;

    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a {
      background-color: #0366d6;
      color: white;
    }
    li.disabled a {
      color: grey;
      background-color: #26B19B !important;
    }
  `;

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />
      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <h4 className="card-title">Daily Deposit Report</h4>
           
              <div className="card-header">
                   <button  className="btn btn-sm btn-success">Total Deposit BDT: {totalAmount} </button>
              <button  className="btn btn-sm btn-warning"> Total Bonus BDT: {totalBonus}</button>
                <div className="d-flex align-items-center">
                  <DatePicker
                    selected={startDate}
                    onChange={setStartDate}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText="Start Date"
                    className="form-control me-2"
                    dateFormat="dd/MM/yyyy"
                  />
                  <DatePicker
                    selected={endDate}
                    onChange={setEndDate}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    placeholderText="End Date"
                    className="form-control me-2"
                    dateFormat="dd/MM/yyyy"
                  />
                  <select value={limit} onChange={(e) => setLimit(Number(e.target.value))} className="me-2">
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                    <option value="all">All</option>
                    <option value="pending">Pending</option>
                    <option value="paid">Paid</option>
                    <option value="reject">Reject</option>
                  </select>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>From</th>
                        <th>Amount BDT</th>
                          <th>Bonus</th>
                        <th>Agent ID</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((deposit, index) => (
                        <tr key={index}>
                          <td>{deposit.user_id}</td>
                          <td>{deposit.send_amount_in_bdt}</td>
                            <td>{deposit.send_amount_in_bdt - deposit.exposure_balance}</td> {/* bonus */}
                          <td>{deposit.agent_id}</td>
                    
                        
                          <td>{formatDate(deposit.createdAt)}</td>
                          
                          <td>
                            {deposit.status === 'paid' ? (
                              <button className="btn btn-sm btn-success">Paid</button>
                            ) : deposit.status === 'reject' ? (
                              <button className="btn btn-sm btn-danger">Rejected</button>
                            ) : (
                              <button className="btn btn-sm btn-danger">Pending</button>
                            )}
                          </td>
                          <td>
                            {deposit.status === 'pending' && (
                              <>
                                <button
                                  className="btn btn-success btn-xs me-1"
                                  onClick={(e) => handleApprovePayment(deposit._id, e)}
                                >
                                  <i className="fa fa-check"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-xs"
                                  onClick={(e) => handleRejectPayment(deposit._id, e)}
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <MyPaginate
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="<"
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Daily_deposit;
